"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.reflect.get");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.set");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.number.constructor");

require("core-js/modules/es6.regexp.split");

var _lodash = _interopRequireDefault(require("lodash"));

var _paste = require("../../constants/paste");

var _closeIcon = require("../../icons/closeIcon");

var _expandIcon = require("../../icons/expandIcon");

var _WithLogic2 = _interopRequireDefault(require("../../utils/WithLogic"));

var _NestedComponent = _interopRequireDefault(require("../nested/NestedComponent"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var TableComponent =
/*#__PURE__*/
function (_WithLogic) {
  _inherits(TableComponent, _WithLogic);

  _createClass(TableComponent, null, [{
    key: "emptyTable",
    value: function emptyTable(numRows, numCols) {
      var rows = [];

      for (var i = 0; i < numRows; i++) {
        var cols = [];

        for (var j = 0; j < numCols; j++) {
          cols.push({
            components: []
          });
        }

        rows.push(cols);
      }

      return rows;
    }
  }, {
    key: "schema",
    value: function schema() {
      for (var _len = arguments.length, extend = new Array(_len), _key = 0; _key < _len; _key++) {
        extend[_key] = arguments[_key];
      }

      return _NestedComponent.default.schema.apply(_NestedComponent.default, [{
        type: 'table',
        input: false,
        key: 'table',
        numRows: 3,
        numCols: 3,
        rows: TableComponent.emptyTable(3, 3),
        header: [],
        caption: '',
        striped: false,
        bordered: false,
        hover: false,
        condensed: false,
        persistent: false
      }].concat(extend));
    }
  }, {
    key: "builderInfo",
    get: function get() {
      return {
        title: 'Table',
        group: 'layout',
        icon: 'fa fa-table',
        weight: 40,
        documentation: 'http://help.form.io/userguide/#table',
        schema: TableComponent.schema()
      };
    }
  }]);

  function TableComponent(component, options, data) {
    var _this;

    _classCallCheck(this, TableComponent);

    var originalRows = _lodash.default.cloneDeep(component.rows);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TableComponent).call(this, component, options, data));

    if (!_lodash.default.isEqual(originalRows, _this.component.rows)) {
      _this.component.rows = originalRows;
    }

    return _this;
  }

  _createClass(TableComponent, [{
    key: "addComponents",

    /**
     *
     * @param element
     * @param data
     */
    value: function addComponents(element, data, options, state) {
      var _this2 = this;

      var totalIndex = 0; // Build the body.

      this.tbody = this.ce('tbody');

      _lodash.default.each(this.component.rows, function (row, rowIndex) {
        var tr = _this2.ce('tr');

        _lodash.default.each(row, function (column, colIndex) {
          var td = _this2.ce('td', {
            id: "".concat(_this2.id, "-").concat(rowIndex, "-").concat(colIndex)
          });

          _lodash.default.each(column.components, function (comp) {
            var component = _this2.addComponent(comp, td, data, null, null, state);

            component.pasteType = _paste.PasteType.table;
            component.tableRow = rowIndex;
            component.tableColumn = colIndex;
            component.index = totalIndex;
            totalIndex++;
          });

          if (_this2.options.builder) {
            if (!column.components || !column.components.length) {
              td.appendChild(_this2.ce('div', {
                id: "".concat(_this2.id, "-").concat(rowIndex, "-").concat(colIndex, "-placeholder"),
                class: 'alert alert-info',
                style: 'text-align:center; margin-bottom: 0px;',
                role: 'alert'
              }, _this2.text('Drag and Drop a form component')));
            }

            _this2.root.addDragContainer(td, _this2, {
              onSave: function onSave(component) {
                component.tableRow = rowIndex;
                component.tableColumn = colIndex;
              }
            });
          }

          tr.appendChild(td);
        });

        _this2.tbody.appendChild(tr);
      });
    }
  }, {
    key: "addComponent",
    value: function addComponent(schema, element, data, before, noAdd, state) {
      var type = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : _paste.AddComponentType.default;

      if (type === _paste.AddComponentType.default) {
        return _get(_getPrototypeOf(TableComponent.prototype), "addComponent", this).call(this, schema, element, data, before, noAdd, state);
      }

      if (type === _paste.AddComponentType.paste) {
        var component = this.createComponent(schema, this.options, data, null, state, true);
        component.tableRow = schema.tableRow;
        component.tableColumn = schema.tableColumn;
        this.components.splice(++schema.index, 0, component);
      }
    }
  }, {
    key: "buildHeader",
    value: function buildHeader() {
      var _this3 = this;

      if (this.component.header && this.component.header.length) {
        var thead = this.ce('thead');
        var thr = this.ce('tr');

        _lodash.default.each(this.component.header, function (header) {
          var th = _this3.ce('th');

          th.appendChild(_this3.text(header));
          thr.appendChild(th);
        });

        thead.appendChild(thr);
        this.table.appendChild(thead);
      }
    }
  }, {
    key: "build",
    value: function build(state) {
      var _this4 = this;

      if (this.component.columnsWidth) {
        this.setMinTableWith();
      }

      this.element = this.ce('div', {
        id: this.id,
        class: "".concat(this.className, "  table-responsive")
      });
      this.element.component = this;
      var tableClass = 'table ';

      _lodash.default.each(['striped', 'bordered', 'hover', 'condensed'], function (prop) {
        if (_this4.component[prop]) {
          tableClass += "table-".concat(prop, " ");
        }
      });

      this.table = this.ce('table', {
        class: tableClass
      });
      var minWidth = isNaN(this.minTableWith) ? '' : "min-width: ".concat(this.minTableWith, "px;"); // обертка необходимая для адаптивности таблиц

      var tableWrapper = this.ce('div', {
        style: "overflow-x: auto; ".concat(minWidth)
      });
      tableWrapper.appendChild(this.table);
      this.buildHeader();
      this.addComponents(null, null, null, state);
      this.table.appendChild(this.tbody);
      this.element.appendChild(tableWrapper);
      this.attachLogic();
      this.fullscreen = false;
      this.addFullScreenMode();

      if (this.component.columnsWidth) {
        this.setColumnsWidth();
      }

      if (this.component.columnsColors) {
        this.setTableColors();
      }
    }
  }, {
    key: "addFullScreenMode",
    value: function addFullScreenMode() {
      var toggleFullScreenModeBtn = this.ce('button', {
        class: 'fullscreen-btn MuiButtonBase-root MuiIconButton-root MuiIconButton-colorPrimary'
      });
      toggleFullScreenModeBtn.addEventListener('click', this.toggleFullScreenMode.bind(this));
      toggleFullScreenModeBtn.innerHTML = _expandIcon.expandIcon;

      if (!this.element.contains(this.toggleFullScreenModeBtn)) {
        this.element.prepend(toggleFullScreenModeBtn);
        this.toggleFullScreenModeBtn = toggleFullScreenModeBtn;
      }
    }
  }, {
    key: "toggleFullScreenMode",
    value: function toggleFullScreenMode() {
      var element = this.getElement();
      element.classList.toggle('formio-component--fullscreen');
      element.style.position = '';
      this.fullscreen = !this.fullscreen;

      if (this.fullscreen) {
        return this.toggleFullScreenModeBtn.innerHTML = _closeIcon.closeIcon;
      }

      return this.toggleFullScreenModeBtn.innerHTML = _expandIcon.expandIcon;
    }
  }, {
    key: "setTableColors",
    value: function setTableColors() {
      var _this5 = this;

      this.component.columnsColors.forEach(function (colorsParams) {
        switch (colorsParams.fillType) {
          case 'column':
            {
              _this5.setColumnsColor(colorsParams);

              break;
            }

          case 'row':
            {
              _this5.setRowsColor(colorsParams);

              break;
            }

          case 'cell':
            {
              _this5.setCellsColor(colorsParams);

              break;
            }
        }
      });
    }
  }, {
    key: "setColumnsColor",
    value: function setColumnsColor(colorsParams) {
      var fillColor = colorsParams.fillColor,
          textColor = colorsParams.textColor,
          fillCoords = colorsParams.fillCoords;

      if (fillCoords.trim()) {
        var columns = this.getCoords(fillCoords);
        var tableRows = this.table.querySelectorAll('tr');
        tableRows.forEach(function (tableRow) {
          columns.forEach(function (columnNumber) {
            var column = tableRow.querySelector("td:nth-child(".concat(columnNumber, ")"));

            if (column) {
              column.style.backgroundColor = fillColor;
              column.style.color = textColor;
            }
          });
        });
      }
    }
  }, {
    key: "setRowsColor",
    value: function setRowsColor(colorsParams) {
      var fillColor = colorsParams.fillColor,
          textColor = colorsParams.textColor,
          fillCoords = colorsParams.fillCoords;

      if (fillCoords.trim()) {
        var rows = this.getCoords(fillCoords);
        var tableRows = this.table.querySelectorAll('tr');
        rows.forEach(function (rowNumber) {
          var row = tableRows[rowNumber - 1];

          if (row) {
            var rowCells = row.querySelectorAll('td');
            rowCells.forEach(function (rowCell) {
              rowCell.style.backgroundColor = fillColor;
              rowCell.style.color = textColor;
            });
          }
        });
      }
    }
  }, {
    key: "setCellsColor",
    value: function setCellsColor(colorsParams) {
      var fillColor = colorsParams.fillColor,
          textColor = colorsParams.textColor,
          fillCoords = colorsParams.fillCoords;

      if (fillCoords.trim()) {
        var coords = this.getCellCoords(fillCoords);
        var tableRows = this.table.querySelectorAll('tr');
        coords.forEach(function (cellCoords) {
          var columnCoord = cellCoords.columnCoord,
              rowCoord = cellCoords.rowCoord;
          var row = tableRows[rowCoord - 1];

          if (row) {
            var cell = row.querySelector("td:nth-child(".concat(columnCoord, ")"));

            if (cell) {
              cell.style.backgroundColor = fillColor;
              cell.style.color = textColor;
            }
          }
        });
      }
    }
  }, {
    key: "getCoords",
    value: function getCoords(coords) {
      var _this6 = this;

      var allCoords = [];

      if (coords.indexOf(';') !== -1) {
        var coordsParts = coords.split(';');
        coordsParts.forEach(function (coords) {
          if (coords.indexOf('-') !== -1) {
            _this6.setCoordsFromSeries(allCoords, coords);
          } else {
            allCoords.push(coords);
          }
        });
        return allCoords;
      }

      if (coords.indexOf('-') !== -1) {
        this.setCoordsFromSeries(allCoords, coords);
        return allCoords;
      }

      allCoords.push(coords);
      return allCoords;
    }
  }, {
    key: "setCoordsFromSeries",
    value: function setCoordsFromSeries(allCoords, coordsSeries) {
      var _coordsSeries$split = coordsSeries.split('-'),
          _coordsSeries$split2 = _slicedToArray(_coordsSeries$split, 2),
          startCoord = _coordsSeries$split2[0],
          lastCoord = _coordsSeries$split2[1];

      startCoord = Number(startCoord);
      lastCoord = Number(lastCoord);

      for (var coord = startCoord; coord <= lastCoord; coord++) {
        allCoords.push(coord.toString());
      }
    }
  }, {
    key: "getCellCoords",
    value: function getCellCoords(coords) {
      var _this7 = this;

      var allCoords = [];

      if (coords.indexOf(';') !== -1) {
        var coordsParts = coords.split(';');
        coordsParts.forEach(function (coordsSet) {
          if (coordsSet.indexOf('-') !== -1) {
            _this7.setCellCoords(allCoords, coordsSet);
          }
        });
        return allCoords;
      }

      this.setCellCoords(allCoords, coords);
      return allCoords;
    }
  }, {
    key: "setCellCoords",
    value: function setCellCoords(allCoords, coords) {
      if (coords.indexOf('-') !== -1) {
        var _coords$split = coords.split('-'),
            _coords$split2 = _slicedToArray(_coords$split, 2),
            columnCoord = _coords$split2[0],
            rowCoord = _coords$split2[1];

        allCoords.push({
          columnCoord: columnCoord,
          rowCoord: rowCoord
        });
      }
    }
  }, {
    key: "setMinTableWith",
    value: function setMinTableWith() {
      var _this8 = this;

      var columnIndexes = new Set();
      this.minTableWith = this.component.columnsWidth.reduce(function (widthCount, columnProperties) {
        var columnIndex = columnProperties.columnPosition;

        if (columnIndex > _this8.component.numCols || columnIndexes.has(columnIndex)) {
          return widthCount;
        }

        if (columnIndex) {
          columnIndexes.add(columnIndex);
        }

        return widthCount + columnProperties.columnWidth;
      }, 0);
      this.columsWithWidthCount = columnIndexes.size;
    }
  }, {
    key: "setColumnsWidth",
    value: function setColumnsWidth() {
      var _this9 = this;

      var tableRows = this.table.querySelectorAll('tr');
      var tableColumns = tableRows[0].querySelectorAll('td');

      if (this.columsWithWidthCount === tableColumns.length) {
        this.table.style.width = 'auto';
      }

      tableRows.forEach(function (row) {
        _this9.setRowsWidth(row);
      });
    }
  }, {
    key: "setRowsWidth",
    value: function setRowsWidth(row) {
      var tableColumns = row.querySelectorAll('td');
      this.component.columnsWidth.forEach(function (columnProperties) {
        var column = tableColumns[columnProperties.columnPosition - 1];

        if (column) {
          var columnWidth = columnProperties.columnWidth;
          column.style.width = columnWidth + 'px';
          column.style.maxWidth = columnWidth + 'px';
        }
      });
    }
  }, {
    key: "defaultSchema",
    get: function get() {
      return TableComponent.schema();
    }
  }, {
    key: "schema",
    get: function get() {
      var schema = _lodash.default.omit(_get(_getPrototypeOf(TableComponent.prototype), "schema", this), 'components');

      schema.rows = TableComponent.emptyTable(this.component.numRows, this.component.numCols);
      this.eachComponent(function (component) {
        var row = schema.rows[component.tableRow];
        var col = row && row[component.tableColumn];

        if (!row || !col) {
          return false;
        }

        schema.rows[component.tableRow][component.tableColumn].components.push(component.schema);
      });
      return schema;
    }
  }]);

  return TableComponent;
}((0, _WithLogic2.default)(_NestedComponent.default));

exports.default = TableComponent;
var tableComponents = [{
  type: 'datagrid',
  input: true,
  label: 'Ширина столбцов',
  key: 'columnsWidth',
  tooltip: 'Укажите номер столбца и ширину в "px"',
  weight: 10,
  defaultValue: null,
  reorder: true,
  components: [{
    type: 'number',
    input: true,
    key: 'columnPosition',
    label: 'Номер столбца',
    valueProperty: 'value',
    validate: {
      min: '0',
      step: '1',
      integer: 'true'
    }
  }, {
    type: 'number',
    input: true,
    key: 'columnWidth',
    label: 'Ширина в пикселях',
    valueProperty: 'value',
    validate: {
      min: '0'
    }
  }]
}, {
  type: 'datagrid',
  input: true,
  label: 'Заливка цветом',
  key: 'columnsColors',
  weight: 11,
  reorder: true,
  tooltip: '' + 'Примеры формата цвета: \n' + '"red" \n' + '"#f40000" \n' + '"#rgb(244, 0, 0);" \n' + '"#rgba(244, 0, 0, 1);" \n',
  components: [{
    type: 'select',
    input: true,
    label: 'Тип заливки',
    key: 'fillType',
    dataSrc: 'values',
    defaultValue: 'column',
    data: {
      values: [{
        label: 'Столбец',
        value: 'column'
      }, {
        label: 'Строка',
        value: 'row'
      }, {
        label: 'Ячейка',
        value: 'cell'
      }]
    }
  }, {
    label: 'Координаты заливки',
    key: 'fillCoords',
    input: true,
    type: 'textfield',
    validate: {
      pattern: '([0-9-;]*)'
    },
    tooltip: '' + '1) СТОЛБЕЦ: Можно указать несколько отдельных столбцов или промежуток. \n' + 'Пример: "1-3;5".  \n' + 'Будут залиты 1, 2, 3, 5 столбцы \n' + '2) СТРОКА: Можно указать указать несколько отдельных строк или промежуток.  \n' + 'Пример: "1-3;5".  \n' + 'Будут залиты 1, 2, 3, 5 строки \n' + '3) ЯЧЕЙКА Укажите номер строки и номер столбца. \n' + 'Можно указать несколько.  \n' + 'Пример: "1-3; 4-2".  \n' + 'Будут залиты третяя ячейка первого столбца и вторая ячейка четвёртого столбца'
  }, {
    label: 'Цвет заливки',
    key: 'fillColor',
    input: true,
    type: 'textfield'
  }, {
    label: 'Цвет текста',
    key: 'textColor',
    input: true,
    type: 'textfield'
  }]
}];